import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { CompanyEmail } from './company-email';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-company-email-modal-update',
  templateUrl: './company-email-modal-update.component.html'
})
export class CompanyEmailModalUpdateComponent extends BaseModalUpdateComponent<CompanyEmail> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<CompanyEmail>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService

  ) { 
    super(modalContainerService, activeModal,modalService);
  }
 

  ngOnInit() {
  }

}
